"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { AppDispatcher } from 'Dispatcher';
import { UserScriptConstants } from "./UserScriptConstants";
import { formEditUpdate } from "Actions/Forms/FormEditActions";
import { navigateToParent } from "Actions/Forms/FormActions";
import { UserScriptModel } from "./UserScriptModel";
import { UserScriptCriticalError, UserScriptWeakError } from "./UserScriptErrors";
import { d5TableUserEvent } from "Actions/Table/D5TableActions";
import { System } from "Constants/objects";
import { showSnackBar } from "Actions/D5SnackbarsActions";
import { sharedData } from 'SharedData';

var UAHandler =
/*#__PURE__*/
function () {
  function UAHandler() {
    var _this = this;

    _classCallCheck(this, UAHandler);

    AppDispatcher.register(function (action) {
      switch (action.actionType) {
        case UserScriptConstants.FORM_EDIT_CUSTOM_ACTION:
          {
            var fileName = action.fileName,
                funcName = action.funcName;

            if (!window[fileName] || typeof window[fileName][funcName] !== 'function') {
              formEditUpdate({
                nextData: action.nextStore,
                nextView: action.viewStore,
                formEvents: {},
                formUUID: action.formUUID,
                funcName: funcName,
                props: {}
              });
            } else {
              _this.invokeEditFunction(action);
            }
          }
          break;

        case UserScriptConstants.TABLE_CUSTOM_ACTION:
          {
            var _action$options = action.options,
                _fileName = _action$options.fileName,
                nextStore = _action$options.nextStore,
                viewStore = _action$options.viewStore,
                formUUID = _action$options.formUUID,
                _funcName = _action$options.funcName,
                rowIndex = _action$options.rowIndex,
                props = _action$options.props;

            if (!window[_fileName] || typeof window[_fileName][_funcName] !== 'function') {
              d5TableUserEvent({
                nextData: nextStore,
                nextView: viewStore,
                formEvents: {},
                formUUID: formUUID,
                funcName: _funcName,
                props: {},
                rowIndex: rowIndex
              });
            } else {
              _this.invokeTableFunction(action.options);
            }
          }
          break;

        default:
          return true;
      }
    });
  }

  _createClass(UAHandler, [{
    key: "invokeEditFunction",
    value: function invokeEditFunction(_ref) {
      var _this2 = this;

      var fileName = _ref.fileName,
          funcName = _ref.funcName,
          nextStore = _ref.nextStore,
          viewStore = _ref.viewStore,
          formUUID = _ref.formUUID,
          rest = _objectWithoutProperties(_ref, ["fileName", "funcName", "nextStore", "viewStore", "formUUID"]);

      var formModel = new UserScriptModel(viewStore, nextStore, rest.props, System.USER_SCRIPTS_INITIATOR.FORM_EDIT);
      this.setUserScriptErrors();

      try {
        var newModel = window[fileName][funcName](formModel);

        if (newModel instanceof Promise) {
          newModel.then(function (model) {
            formEditUpdate({
              nextData: model.getSourceData(),
              nextView: model.getSourceView(),
              props: model.getProps(),
              formEvents: _objectSpread({}, model.formEvents),
              formUUID: formUUID,
              funcName: funcName
            });
          }).catch(function (e) {
            if (e instanceof UserScriptWeakError || e instanceof UserScriptCriticalError) {
              _this2.cancelOpenForm(e, formUUID);
            } else {
              formEditUpdate({
                nextData: nextStore,
                nextView: viewStore,
                formEvents: {},
                props: {},
                formUUID: formUUID,
                funcName: funcName,
                errorMessage: e.message
              });
            }
          });
        } else {
          formEditUpdate({
            nextData: newModel.getSourceData(),
            nextView: newModel.getSourceView(),
            props: newModel.getProps(),
            formEvents: _objectSpread({}, newModel.formEvents),
            formUUID: formUUID,
            funcName: funcName
          });
        }
      } catch (e) {
        if (e instanceof UserScriptWeakError || e instanceof UserScriptCriticalError) {
          this.cancelOpenForm(e, formUUID);
        } else {
          formEditUpdate({
            nextData: nextStore,
            nextView: viewStore,
            formEvents: {},
            formUUID: formUUID,
            funcName: funcName,
            props: {},
            errorMessage: e.message
          });
        }
      }
    }
  }, {
    key: "invokeTableFunction",
    value: function invokeTableFunction(_ref2) {
      var fileName = _ref2.fileName,
          funcName = _ref2.funcName,
          nextStore = _ref2.nextStore,
          viewStore = _ref2.viewStore,
          formUUID = _ref2.formUUID,
          rowIndex = _ref2.rowIndex,
          rest = _objectWithoutProperties(_ref2, ["fileName", "funcName", "nextStore", "viewStore", "formUUID", "rowIndex"]);

      var formModel = new UserScriptModel(viewStore, nextStore, rest.props, System.USER_SCRIPTS_INITIATOR.TABLE);

      try {
        var newModel = window[fileName][funcName](formModel);

        if (newModel instanceof Promise) {
          newModel.then(function (model) {
            d5TableUserEvent({
              nextData: model.getSourceData(),
              nextView: model.getSourceView(),
              props: model.getProps(),
              formEvents: _objectSpread({}, model.formEvents),
              formUUID: formUUID,
              rowIndex: rowIndex,
              funcName: funcName
            });
          }).catch(function (e) {
            //owner - UserScriptModel, _owner - FormEditStore
            if (newModel.owner) {
              newModel._owner.updating = funcName;
              formEditUpdate({
                nextData: newModel.owner.getSourceData(),
                nextView: newModel.owner.getSourceView(),
                props: {},
                formEvents: {},
                formUUID: newModel._owner.formUUID,
                funcName: funcName
              });
            }

            d5TableUserEvent({
              nextData: nextStore,
              nextView: viewStore,
              formEvents: {},
              errorMessage: e.message,
              props: {},
              formUUID: formUUID,
              funcName: funcName,
              rowIndex: rowIndex
            });
          });
        } else {
          //owner - UserScriptModel, _owner - FormEditStore
          if (newModel.owner) {
            newModel._owner.updating = funcName;
            formEditUpdate({
              nextData: newModel.owner.getSourceData(),
              nextView: newModel.owner.getSourceView(),
              props: {},
              formEvents: {},
              formUUID: newModel._owner.formUUID,
              funcName: funcName
            });
          }

          d5TableUserEvent({
            nextData: newModel.getSourceData(),
            nextView: newModel.getSourceView(),
            props: newModel.getProps(),
            formEvents: _objectSpread({}, newModel.formEvents),
            formUUID: formUUID,
            rowIndex: rowIndex,
            funcName: funcName
          });
        }
      } catch (e) {
        d5TableUserEvent({
          nextData: nextStore,
          nextView: viewStore,
          formEvents: {},
          props: {},
          errorMessage: e.message,
          formUUID: formUUID,
          funcName: funcName,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "setUserScriptErrors",
    value: function setUserScriptErrors() {
      if (!window.hasOwnProperty('UserScriptCriticalError')) window.UserScriptCriticalError = UserScriptCriticalError;
      if (!window.hasOwnProperty('UserScriptWeakError')) window.UserScriptWeakError = UserScriptWeakError;
    }
  }, {
    key: "cancelOpenForm",
    value: function cancelOpenForm(e, formUUID) {
      setTimeout(function () {
        return navigateToParent(formUUID);
      });
      sharedData.formEditProcessed = null;
      if (e.message) showSnackBar({
        type: System.SNACKBAR_TYPES.Error,
        message: e.message
      });
    }
  }]);

  return UAHandler;
}();

var userScriptHandler = new UAHandler();